<script>
    import './TailwindStyles.svelte'
    import {isOffline} from "./services/configService";
    import {tick, onDestroy, onMount} from 'svelte';
    import {update_from_url, getURLProduct} from './Utils/RouterUtils.svelte';
    import {clean_the_url} from './Utils/RouterUtils.svelte';
    import {store, video_store} from './Utils/stores.js';
    import {youTubeInitialized} from './Utils/youtubeStore';
    import Search from "./Search.svelte";
    import {fetchVideoData} from "./services/sanityService";
    import FilteredVideos from "./FilteredVideos.svelte";
    import {active_video_store} from "./Utils/stores.js";
    import CategoryView from "./CategoryView.svelte";
    import PlayListView from "./PlayListView.svelte";
    import ProjectView from "./ProjectView.svelte";
    import ActivePlaylistView from "./ActivePlaylistView.svelte";
    import ActiveCategoryView from "./ActiveCategoryView.svelte";
    import ActiveProjectView from "./ActiveProjectView.svelte";
    import VideoPlayerModal from "./VideoPlayerModal.svelte";
    import LoginButton from "./LoginButton.svelte";
    import NextUp from "./NextUp.svelte";

    $: loading = false;

    function loadAllVideos(product) {
        console.log("Loading all videos for product: ", product)
        loading = true;
        fetchVideoData()
            .then(res => {
                console.log(res)
                video_store.set({product: product, ...res})
                update_from_url()
            }).finally(() => {
                setTimeout(() => {
                    loading = false;
                }, 1000)
        });
    }

    onMount(() => {
        // Async init the youtube API
        let ytTagUrl = "https://www.youtube.com/iframe_api";
        let tag = document.createElement("script");
        tag.src = ytTagUrl;
        let firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = function () {
            youTubeInitialized.update(v => true);
        };
        const product = getURLProduct();
        loadAllVideos(product);
        clean_the_url();
    })

    let tutorialContainer = null;

    async function handlePlaylistSelected(event) {
        if (tutorialContainer) {
            await tick();
            tutorialContainer.scrollIntoView({behavior: "smooth"});
        }
    }

    let activeVideo = null
    let activePlaylist = null
    let showPlayer = false;
    $:{
        if ($active_video_store.active_playlist !== null) {
            activePlaylist = $active_video_store.active_playlist;
            activeVideo = $active_video_store.active_video ?? false
            showPlayer = true;
        } else if ($active_video_store.active_category !== null) {
            activePlaylist = $active_video_store.active_category;
            activeVideo = $active_video_store.active_video ?? false
            showPlayer = true;
        } else if ($active_video_store.active_project !== null) {
            activePlaylist = $active_video_store.active_project;
            activeVideo = $active_video_store.active_video ?? false
            showPlayer = true;
        } else if (($store.search !== null) && $active_video_store.active_video) {
            activePlaylist = $active_video_store.active_playlist;
            activeVideo = $active_video_store.active_video ?? false
            showPlayer = true;
        } else {
            activePlaylist = null;
            activeVideo = null;
            showPlayer = false
        }

    }
    $:{
        if (showPlayer && activeVideo) {
            // Set the overflow-y to hidden on the body
            console.log("Setting overflow to hidden");
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }


</script>
<main id="tutorialBrowserTop" class="vec-container vec-mx-auto vec-font-sans test">
    {#if loading}
        <div class="vec-flex vec-flex-col vec-items-center vec-p-12 vec-space-y-6">
            <svg class="vec-w-12 vec-h-12 vec-text-lighterGrey vec-animate vec-animate-spin" viewBox="0 0 64 64" fill="none"
                 xmlns="http://www.w3.org/2000/svg" >
                <path
                        d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                        stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                <path
                        d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                        stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="vec-text-darkerGrey">
                </path>
            </svg>
            <p class="vec-font-semibold vec-text-lg">Fetching Tutorial Videos</p>
        </div>

    {:else}
        {#if !isOffline()}
            <div class=" vec-my-5 vec-px-5 ">
                <div class="vec-flex vec-flex-row md:vec-items-center md:vec-justify-between vec-w-full vec-mx-auto vec-max-w-screen-md">
                    <div class="vec-w-full mt-4">
                        <Search/>
                    </div>
                    <LoginButton/>
                </div>
            </div>
        {/if}
        {#if showPlayer && activeVideo}
            <VideoPlayerModal bind:showModal={showPlayer} video={activeVideo} playlist={activePlaylist}/>
        {/if}

        {#if $active_video_store.active_playlist !== null}
            <ActivePlaylistView/>
        {:else if $active_video_store.active_category !== null}
            <ActiveCategoryView/>
        {:else if $active_video_store.active_project !== null}
            <ActiveProjectView/>
        {:else if $store.search !== null}
            <FilteredVideos/>
        {:else}
            <div class="container-fluid px-5">
                <div class="lg:vec-w-1/2">
                    <NextUp/>
                </div>
            </div>

            {#if !$store.machinable_only}
                <PlayListView/>
            {/if}
            <CategoryView/>
        {/if}
    {/if}
</main>
